const siteEffects = {
  cursorTrail: false,
}

export default siteEffects
